import { render, staticRenderFns } from "./MenuFormDrawer.vue?vue&type=template&id=c6000ad8&scoped=true"
import script from "./MenuFormDrawer.vue?vue&type=script&lang=js"
export * from "./MenuFormDrawer.vue?vue&type=script&lang=js"
import style0 from "./MenuFormDrawer.vue?vue&type=style&index=0&id=c6000ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6000ad8",
  null
  
)

export default component.exports